import React from 'react';
import './HomeCTA.css';

export function HomeCTA() {
  return (
    <section className="home-cta">
      <div className="home-cta-background">
        <div className="cta-glow cta-glow-1"></div>
        <div className="cta-glow cta-glow-2"></div>
        <div className="cta-glow cta-glow-3"></div>
      </div>

      <div className="home-cta-content">
        <div className="cta-badge-final">
          <span>Ready to Transform Your Business?</span>
        </div>
        <h2 className="home-cta-title">
          Let's Build Something<br />
          <span className="cta-gradient">Extraordinary Together</span>
        </h2>
        <p className="home-cta-subtitle">
          Join hundreds of businesses that trust SFrays for their digital transformation.<br />
          Your success story starts with a conversation.
        </p>
        <div className="home-cta-actions">
          <button className="btn btn-primary cta-btn-home">Schedule a Consultation</button>
          <button className="btn btn-secondary cta-btn-home cta-btn-outline">View Case Studies</button>
        </div>

        <div className="cta-trust-badges">
          <div className="trust-item">
            <div className="trust-icon">🏆</div>
            <span>Award-Winning Team</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <div className="trust-icon">🔒</div>
            <span>Enterprise Security</span>
          </div>
          <div className="trust-divider"></div>
          <div className="trust-item">
            <div className="trust-icon">⚡</div>
            <span>Rapid Delivery</span>
          </div>
        </div>
      </div>
    </section>
  );
}
